import { useContext, useState} from "react";
import Chart from "chart.js/auto";
import { Line } from 'react-chartjs-2';
import ManualScroll from './ManualScroll'
import { MyContext } from "../../context";
import ClientSettingPersonalInfo from "./ClientSettingPersonalInfo"
import ClientSettingPersonalEdit from "./ClientSettingPersonlEdit"
import ClientSettingPassword from "./ClientSettingPassword"



//-------------------------------------------

import PieChart from './PieChart';
import LineChart from './LineChart';

//Chart.register(CategoryScale);



function ClientSettingCode(){

    const {  updateInstallationLinkSelection  } = useContext(MyContext);

    const active = "BIcon active";
    const notActive = "BIcon";

    const [settingRight, setSettingRight] = useState("");

    let SideEdit = () => {
        switch (settingRight) {
          case "":
            return (
              <>
                <ClientSettingPersonalInfo />
              </>
            );
            break;
    
          case "Edit":
            return (
              <>
               <ClientSettingPersonalEdit />
              </>
            );
            break;
    
          case "Change":
            return (
              <>
               <ClientSettingPassword />
              </>
            );
            break;
    
            
        }
      };
    

    return (
       
        <>
          <div class="row">
   
        {SideEdit()}



<div class="col-sm-3">



<div className="card" style={{width: "18rem;", marginBottom: "30px"}}>
  <div className="card-body">
    <div style={{display: "flex"}}>
    <p className="card-title"><strong>Setting Edit</strong></p> 
    
    
    {/*<span className='info leftAling'><span class="material-symbols-rounded">more_horiz</span></span>*/}</div>

   
<div className='d-flex'>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">menu_book</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Edit Personal | Change Password </strong></span>

    
    </div>

    
  </div>
    <hr />

{/*-------------------------*/}


  <p><strong>Edit: </strong></p>
<div  style={{display: "flex"}}>

<span style={{width:"100%"}}>

{settingRight === "" ? <span className="BIcon3" onClick={() => setSettingRight("Edit")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >person</span> <span style={{paddingTop:"2px", paddingLeft:"5px"}}>Edit Personal Enformation</span></span> 
:
<span className="BIcon3" onClick={() => setSettingRight("")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >person</span> <span style={{paddingTop:"2px", paddingLeft:"5px"}}>Personal Enformation</span></span> 
}


</span>

</div>

<hr />

<div  style={{display: "flex"}}>

<span style={{width:"100%"}}>



<span className="BIcon3" onClick={() => setSettingRight("Change")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >person</span> <span style={{paddingTop:"2px", paddingLeft:"5px"}}>Change Password</span></span>
</span>

</div>

{/*-------------------------*/}
  </div>
</div>


</div>



          </div>


          {/* Id 0x35C*/}

        </>
    )
}

export default ClientSettingCode;